import { Message } from '../../core/message';
import { Response, Event } from './requests';

export type VideoRoomPluginData = {
    plugin: 'janus.plugin.videoroom';
    data: Response | Event;
}

export type AsVideoRoomPluginMessage<T> = Extract<T, { plugindata: unknown }> & { plugindata: VideoRoomPluginData }

export type VideoRoomPluginMessage = AsVideoRoomPluginMessage<Message>

export function isVideoRoomPluginMessage<T extends Message>(msg: T | VideoRoomPluginMessage): msg is AsVideoRoomPluginMessage<T> {
    if ('plugindata' in msg) {
        if (msg.plugindata.plugin === 'janus.plugin.videoroom') return true;
    }
    return false;
}
